<script setup lang="ts">
import { JPCCurrency } from 'assets/data/icons';

const Icon = useIcon();

interface IProps {
  viewBox?: string;
  fill?: string;
  bindingClass?: string | string[] | { [key: string]: boolean };
}

withDefaults(defineProps<IProps>(), {
  fill: `url(#goldGradient)`,
  bindingClass: '!w-3 !h-3 gold-gradient-text',
  viewBox: '0 0 189.07 283',
});
</script>
<template>
  <Icon
    :path="JPCCurrency"
    :class="[bindingClass]"
    filled
    :bindings="{ fill, viewBox }"
  />
</template>
